import { Api } from "@/api";
import { PublisherType, PaginationType, UserLoginType } from "@/DTO";
import { ConvertToPaginationType } from "@/api/help";
import { ConvertToPublisherType } from "@/api/publisher/get";

export const GetPublisherList = (user: UserLoginType, pagination: PaginationType, searchData?: string) => {
  return new Promise<{
    data: PublisherType[]
    pagination: PaginationType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `publisher`,
      params: {
        page: pagination.currentPage,
        per_page: pagination.perPage,
        name: searchData
      },
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToPublisherListType(data.data),
          pagination: ConvertToPaginationType(data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToPublisherListType = (data: any[]): PublisherType[] => {
  const returnData = data.map((item) => {
    return ConvertToPublisherType(item);
  });
  return returnData;
};

